// src/components/Users/VideoModal.js
import React from 'react';

const VideoModal = ({ videoUrl, onClose }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
      {/* Video container */}
      <div className="bg-white p-4 rounded-lg shadow-lg max-h-[90vh] max-w-[90vw] overflow-auto">
        <video controls autoPlay className="w-full max-h-[80vh]">
          <source src={videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      {/* Close button fixed at the top-right corner of the viewport */}
      <button
        onClick={onClose}
        className="fixed top-4 right-4 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 focus:outline-none"
      >
        Close
      </button>
    </div>
  );
};

export default VideoModal;
